<script>
import orderBy from 'lodash/orderBy'

import FeatureInput from '@/components/cars/edit/FeatureInput.vue'
import QuickActionTile from '@/components/ui/QuickActionTile.vue'

export default {
  components: {
    'mia-feature-input': FeatureInput,
    'mia-quick-action-tile': QuickActionTile
  },

  props: {
    groups: {
      type: Array,
      required: true
    },

    tiles: {
      type: Array,
      required: true
    }
  },

  data: () => ({
    searchQuery: ''
  }),

  computed: {
    filteredTiles() {
      if (this.searchQuery.trim().length === 0) {
        return this.tiles
      }

      return this.tiles.filter(tile => this.resolveLabel(tile).toLowerCase().includes(this.searchQuery.trim().toLowerCase()))
    },

    groupedTiles() {
      const groupedTiles = this.groups.map(group => ({
        ...group,
        tiles: orderBy(this.filteredTiles.filter(tile => tile.group === group.id), (tile) => {
          if (tile.disabled === undefined) {
            return 0
          }

          if (typeof tile.disabled === 'function') {
            return tile.disabled() ? 1 : 0
          }

          return tile.disabled ? 1 : 0
        })
      }))

      return [...groupedTiles, {
        id: 'ungrouped',
        label: 'Weitere',
        tiles: orderBy(this.filteredTiles.filter(tile => !tile.group), (tile) => {
          if (tile.disabled === undefined) {
            return 0
          }

          if (typeof tile.disabled === 'function') {
            return tile.disabled() ? 1 : 0
          }

          return tile.disabled ? 1 : 0
        })
      }]
    }
  },

  methods: {
    resolveLabel(tile) {
      if (typeof tile.label === 'function') {
        return tile.label()
      }

      return tile.label
    }
  }
}
</script>

<template>
  <div class="px-10 py-12">
    <div class="w-1/2">
      <mia-feature-input
        v-model="searchQuery"
        label="Schnellsuche"
        placeholder="Aktionen durchsuchen..."
        type="search"
      />
    </div>
    <div
      class="space-y-8 mt-6 wrapper"
      style="min-height: 600px"
    >
      <template v-for="group in groupedTiles">
        <div
          v-if="group.tiles.length > 0"
          :key="group.id"
        >
          <div>
            <div class="text-xl">
              {{ group.label }}
            </div>
            <div
              class="mt-1"
              style="height: 2px; background: linear-gradient(90deg, rgba(245,130,31,1) 0%, rgba(245,130,31,0) 100%);"
            />
          </div>
          <div class="mt-2 gap-10 py-4 tile-grid">
            <template v-for="tile in group.tiles">
              <mia-quick-action-tile
                v-if="tile.viewable && typeof tile.viewable === 'function' ? tile.viewable() : (tile.viewable || false)"
                :key="tile.id"
                v-tooltip="(tile.disabled !== undefined ? (typeof tile.disabled === 'function' ? (tile.disabled() !== false) : !!tile.disabled) : false) ? (typeof tile.disabled === 'function' ? tile.disabled() : tile.disabled) : ''"
                class="mx-auto"
                :class="{
                  'cursor-not-allowed': (tile.disabled !== undefined ? (typeof tile.disabled === 'function' ? (tile.disabled() !== false) : tile.disabled) : false),
                  [tile.classes || '']: true
                }"
                :icon="tile.icon || undefined"
                :icon-type="tile.iconType || 'streamline'"
                :disabled="tile.disabled !== undefined ? (typeof tile.disabled === 'function' ? (tile.disabled() !== false) : tile.disabled) : false"
                :highlight="searchQuery.trim()"
                :content="typeof tile.label === 'function' ? tile.label() : tile.label"
                size="small"
                v-on="tile.listeners || {}"
              >
                <template
                  v-if="tile.iconComponent"
                  #icon
                >
                  <div class="h-8">
                    <component
                      :is="tile.iconComponent"
                      v-bind="tile.iconAttrs || {}"
                    />
                  </div>
                </template>
              </mia-quick-action-tile>
            </template>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<style scoped>
.wrapper {
  container-type: inline-size;
}

.tile-grid {
  @apply grid;
  @apply grid-cols-1;
}

@container (min-width: 370px) {
  .tile-grid {
    @apply grid-cols-2 !important;
  }
}

@container (min-width: 600px) {
  .tile-grid {
    @apply grid-cols-3 !important;
  }
}

@container (min-width: 740px) {
  .tile-grid {
    @apply grid-cols-4 !important;
  }
}

@container (min-width: 900px) {
  .tile-grid {
    @apply grid-cols-5 !important;
  }
}

@container (min-width: 1060px) {
  .tile-grid {
    @apply grid-cols-6 !important;
  }
}

@container (min-width: 1300px) {
  .tile-grid {
    @apply grid-cols-7 !important;
  }
}

@container (min-width: 1460px) {
  .tile-grid {
    @apply grid-cols-8 !important;
  }
}

@container (min-width: 1620px) {
  .tile-grid {
    @apply grid-cols-9 !important;
  }
}

@container (min-width: 1780px) {
  .tile-grid {
    @apply grid-cols-10 !important;
  }
}

@container (min-width: 1940px) {
  .tile-grid {
    @apply grid-cols-11 !important;
  }
}

@container (min-width: 2100px) {
  .tile-grid {
    @apply grid-cols-12 !important;
  }
}
</style>
